module.exports = __webpack_public_path__ + "b177afb4869a7d8ff4cd349e71edea00.png";